import React from "react";
import "../scss/portfolio.scss";

const Portfolio = (props) => {
  const project = props.project;
  return (
    <div id={project.id} className="portfolio">
      <div className="portfolio_title">
        <h3>{project.title}</h3>
      </div>
      <div className="portfolio_details">
        <p>{project.content}</p>
        <a target="blank" href={project.link}>
          View project <i className="fa-solid fa-arrow-right-long"></i>
        </a>
        <a target="blank" href={project.code}>
          View code <i className="fa-solid fa-arrow-right-long"></i>
        </a>
      </div>
      <div className="portfolio_image">
        <img src={`/projects/${project.image}.png`} alt={project.title} />
      </div>
    </div>
  );
};

export default Portfolio;
